import { TiktokOneReportingService } from '@/app/services/tiktok-one-reporting/tiktok-one-reporting.service';
import { Component, inject, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ManageBriefTabsService } from '../../pages/manage-brief-tabs/service/manage-brief-tabs/manage-brief-tabs.service';

@Component({
  selector: 'atom-individual-post-results-tto',
  imports: [],
  templateUrl: './individual-post-results-tto.html',
  styleUrl: './individual-post-results-tto.css',
})
export class IndividualPostResultsTtoComponent implements OnInit {
  /** Services */
  private ttoReportingService = inject(TiktokOneReportingService);
  private manageBriefTabsService = inject(ManageBriefTabsService);
  /** Services END */

  ngOnInit(): void {
    console.log('🚨 IndividualPostResultsTto -> ngOnInit');
    this.getTtoReportingData();
    // this.getTtoCampaign();
  }

  async getTtoReportingData() {
    const tto_campaign_id = this.manageBriefTabsService.focussedBrief()?.shoutBrief?.ttoCampaignId;
    if (!tto_campaign_id) {
      return;
    }
    const ttoReportingData = await firstValueFrom(this.ttoReportingService.getIndividualPostResults(tto_campaign_id));
    console.log('🚨 IndividualPostResultsTto -> getTtoReportingData -> ttoReportingData: ', ttoReportingData);
  }

  async getTtoCampaign() {
    const ttoCampaign = await firstValueFrom(this.ttoReportingService.getTtoCampaign());
    console.log('🚨 IndividualPostResultsTto -> getTtoCampaign -> ttoCampaign: ', ttoCampaign);
  }
}
